/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Countrieswhitelist2Inputs */

const id_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar Putih Negara`)
};

const ms_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senarai Putih Negara`)
};

const da_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landehvidliste`)
};

const de_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länder-Freigabeliste`)
};

const en_us2_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countries Whitelist`)
};

const es_es2_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista blanca de países`)
};

const es_mx2_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista blanca de países`)
};

const fil_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whitelist ng mga Bansa`)
};

const fr_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste blanche de pays`)
};

const it_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paesi in whitelist`)
};

const hu_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Országok fehérlista`)
};

const nl_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landen witte lijst`)
};

const no_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land hviteliste`)
};

const pl_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biała lista krajów`)
};

const pt_br2_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista branca de países`)
};

const pt_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista branca de países`)
};

const ro_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listă albă țări`)
};

const fi_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maasallintalista`)
};

const sv_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ländervitlista`)
};

const vi_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách trắng quốc gia`)
};

const tr_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülke Beyaz Listesi`)
};

const cs_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bílá listina zemí`)
};

const bg_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бял списък на държави`)
};

const ru_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Белый список стран`)
};

const uk_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Білий список країн`)
};

const ar_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القائمة البيضاء للدول`)
};

const hi_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देशों की व्हाइटलिस्ट`)
};

const th_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีขาวประเทศ`)
};

const ja_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホワイトリスト国`)
};

const zh_cn2_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国家/地区白名单`)
};

const zh_hant1_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`國家/地區白名單`)
};

const ko_offerdetail_table_countrieswhitelist2 = /** @type {(inputs: Offerdetail_Table_Countrieswhitelist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`국가 화이트리스트`)
};

/**
* | output |
* | --- |
* | "Countries Whitelist" |
*
* @param {Offerdetail_Table_Countrieswhitelist2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_countrieswhitelist2 = /** @type {((inputs?: Offerdetail_Table_Countrieswhitelist2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Countrieswhitelist2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "ms") return ms_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "da") return da_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "de") return de_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "fil") return fil_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "fr") return fr_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "it") return it_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "hu") return hu_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "nl") return nl_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "no") return no_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "pl") return pl_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "pt") return pt_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "ro") return ro_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "fi") return fi_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "sv") return sv_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "vi") return vi_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "tr") return tr_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "cs") return cs_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "bg") return bg_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "ru") return ru_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "uk") return uk_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "ar") return ar_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "hi") return hi_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "th") return th_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "ja") return ja_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_countrieswhitelist2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_countrieswhitelist2(inputs)
	return ko_offerdetail_table_countrieswhitelist2(inputs)
});
export { offerdetail_table_countrieswhitelist2 as "offerDetail.table.countriesWhitelist" }